import { Home, Compass, Navigation, User, Shield, Music, BarChart3 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

type SidebarProps = {
  activeView: 'map' | 'discover' | 'nearby' | 'profile' | 'admin' | 'playlists' | 'analytics';
  onViewChange: (view: 'map' | 'discover' | 'nearby' | 'profile' | 'admin' | 'playlists' | 'analytics') => void;
  isAdmin?: boolean;
};

export function Sidebar({ activeView, onViewChange, isAdmin }: SidebarProps) {
  const { t } = useLanguage();

  const menuItems = [
    { id: 'map' as const, icon: Home, label: t('sidebar.map') },
    { id: 'nearby' as const, icon: Navigation, label: t('sidebar.nearby') },
    { id: 'discover' as const, icon: Compass, label: t('sidebar.discover') },
    { id: 'playlists' as const, icon: Music, label: 'Playlists' },
    { id: 'analytics' as const, icon: BarChart3, label: 'Analytics' },
    { id: 'profile' as const, icon: User, label: 'Profile' },
    ...(isAdmin ? [{ id: 'admin' as const, icon: Shield, label: 'AI Admin' }] : []),
  ];

  return (
    <aside className="bg-gray-800 border-r border-gray-700 w-20 sm:w-64 flex flex-col">
      <nav className="flex-1 p-4 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeView === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onViewChange(item.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                isActive
                  ? 'bg-[#00c7b7] text-white font-semibold shadow-lg shadow-[#00c7b7]/20'
                  : 'text-gray-300 hover:bg-gray-700 hover:text-white'
              }`}
            >
              <Icon className={`w-6 h-6 ${isActive ? 'text-white' : 'text-gray-400'}`} />
              <span className="hidden sm:block">{item.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}
